<template>
  <div
    v-if="contractObject"
    class="nopads calendar-item-container"
  >
    <div class="d-flex flex-row w-100">
      <div
        class="contract-header-text"
        :style="{ minWidth: textColWidthPercentage + '%', width: '100%'}"
        :class="{ expanded: ordersVisible }"
      >
        <font-awesome-icon
          icon="caret-right"
          class="pointer ms-1 me-1 fa-w-6"
          style="outline: none"
          :class="{ 'fa-rotate-90': ordersVisible }"
          @click.stop="toggleOrders(false)"
        />

        <span
          :id="'c_t_' + contractObject.id"
          class="ms-2"
          :class="{ 'disabled-contract': disableContractSelection }"
          @click.stop="$emit('showContract', contractObject)"
        >
          {{ contractObject.id }} - {{ contractObject.name }} ({{
            contractObject.customer ? contractObject.customer.name : null
          }})
        </span>
        <div
          class="me-2 pointer"
          style="float: right"
          @click.stop="toggleOrders(!ordersVisible)"
        >
          <i
            v-if="!ordersVisible"
            class="fa fa-plus"
          />
          <i
            v-else
            class="fa fa-minus"
          />
        </div>
      </div>


      <div
        id="timeline-container"
        style="display: inline-block; position: relative"
      >
        <div
          v-for="(week, index) in weeks"
          :key="index"
          class="week-item"
          :style="{ width: weekColWidth + 'px' }"
        >
          {{ "-" }}
        </div>
        <time-line-item
          v-if="contractObject.start_date && contractObject.end_date"
          :time-col-width="weekColWidth"
          :timeline-start-date="new Date(calendarStartDate)"
          :calendar-start-date="new Date(calendarStartDate)"
          :visible-weeks-limit="visibleWeeksLimit"
          :calendar-start-week="calendarStartWeek"
          :start-date="startDate"
          :end-date="endDate"
          :static="true"
        />
      </div>
    </div>
    <!--    <div style="display: flex; flex-direction: row; align-items: center; width: 100%; margin-top: 1em;">
      <button
        class="btn btn-link"
        type="button"
        @click="ordersVisible = !ordersVisible"
      >
        {{ ordersVisible ? 'Hide Orders' : 'Show Orders' }}
      </button>
    </div>-->

    <div
      v-show="ordersVisible"
      style="display: flex; flex-wrap: wrap"
    >
      <div
        v-if="loading > 0"
        class="loading-container"
      >
        {{ $t("common.loading") }}
      </div>

      <div
        v-else
        style="display: flex; flex-wrap: wrap; align-items: flex-start; width: 100%"
      >
        <div class="d-flex flex-row w-100">
          <div
            class="order-text row border-top"
            :style="{width: '100%', minWidth: textColWidthPercentage + '%', borderTop: 'none' }"
          >
            <div
              class="row col-12"
              style="padding: 0 0;"
            >
              <div
                class="col-8 single-line"
                style="border: none; padding-left: 2.5em"
              >
                {{ $t("calendar.customer") }}: {{ contractObject.customer.name }}
              </div>
              <div
                class="col-4 nopads text-end"
                style="padding-right: 0; "
              >
                <div class="dropdown">
                  <button
                    class="btn btn-outline-secondary btn-sm dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                  <!-- {{ $t('calendar.actions') }} -->
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.stop.prevent="emitAddOrder"
                      >
                        {{ $t("calendar.add_order") }}
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.stop.prevent="emitAddAssignment"
                      >
                        {{ $t("calendar.add_work_assignment_contract") }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- empty div to keep first child of this container on precise width with others -->
          <div style="min-width: 980px" />
        </div>

        <br>

        <duty-officer-schedule-calendar-item
          ref="dutyOfficer"
          :calendar-start-week="calendarStartWeek"
          :calendar-start-date="new Date(calendarStartDate)"
          :visible-weeks-limit="visibleWeeksLimit"
          :time-col-width="timeColWidth"
          :text-col-width-percentage="40"
          :schedules="dutyOfficerSchedules"
          :contract-id="contract ? contract.id : null"
          @update-duty-officer-schedule="fetchDutyOfficerSchedules"
          @select-duty-officer-user="$emit('selectDutyOfficerUser', $event)"
        />

        <!-- Orders -->
        <order-calendar-item
          v-for="order in orders"
          :key="order.id"
          :order="order"
          :assignments="getOrderAssignments(order.id)"
          :show-all="showAll"
          :time-col-width="weekColWidth"
          :visible-weeks-limit="visibleWeeksLimit"
          :calendar-start-date="calendarStartDate"
          :text-col-width-percentage="textColWidthPercentage"
          :selected-limiter="filter"
          :assignment-filter="assignmentFilter"
          :calendar-start-week="calendarStartWeek"
          @show-order="emitShowOrder"
          @show-assignment="emitShowAssignment"
          @add-assignment="emitAddAssignment"
          @order-updated="$emit('orderUpdated')"
        />

        <div class="d-flex flex-row w-100">
          <div
            class="order-text single-line d-flex align-items-center"
            :style="{
              width: '100%',
              minWidth: textColWidthPercentage + '%',
              fontWeight: 'bold',
              color: '#636364',
              paddingLeft: '3.5em',
            }"
          >
            <font-awesome-icon
              icon="caret-right"
              class="pointer ms-1"
              style="outline: none"
              :class="{ 'fa-rotate-90': assignmentsVisible }"
              @click.stop="toggleAssignments"
            />
            <span class="ms-4">
              {{ $t("calendar.assignments_no_order") }} ({{ orderlessAssignments.length }})
            </span>
          </div>
          <div style="min-width: 980px" />
        </div>

        <div v-show="assignmentsVisible">
          <assignment-calendar-item
            v-for="assignment in orderlessAssignments"
            :key="assignment.id"
            :assignment="assignment"
            :time-col-width="weekColWidth"
            :calendar-start-date="calendarStartDate"
            :visible-weeks-limit="visibleWeeksLimit"
            :calendar-start-week="calendarStartWeek"
            :text-col-width-percentage="textColWidthPercentage"
            :assignments-selected-limiter="assignmentFilter"
            @show-assignment="emitShowAssignment"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeUtils } from "@/components/mixins/TimeUtils";
import { restApi } from "@/components/mixins/RestApiMixin";
import TimeLineItem from "@/components/contractcalendar/TimeLineItem";
import { orderMixin } from "@/components/mixins/OrderMixin";
import { workAssignmentHelper } from "@/components/mixins/WorkAssignmentMixin";
import OrderCalendarItem from "@/components/contractcalendar/OrderCalendarItem";
import AssignmentCalendarItem from "@/components/contractcalendar/AssignmentCalendarItem";
import dutyOfficerScheduleCalendarItem from "@/components/contractcalendar/DutyOfficerScheduleCalendarItem.vue";

export default {
    name: "ContractCalendarItem",
    components: { dutyOfficerScheduleCalendarItem, AssignmentCalendarItem, OrderCalendarItem, TimeLineItem },
    mixins: [timeUtils, restApi, orderMixin, workAssignmentHelper],
    props: {
        contract: {
            type: Object,
            default: null,
        },
        textColWidthPercentage: {
            type: Number,
            default: 40,
        },
        timeColWidth: {
            type: Number,
            default: 100, // px
        },
        calendarStartDate: {
            type: Date,
            default: null,
        },
        visibleWeeksLimit: {
            type: Number,
            default: 20,
        },
        calendarStartWeek: {
            type: Number,
            default: 10,
        },
        filter: {
            type: Array,
            default: null,
        },
        assignmentFilter: {
            type: Array,
            default: null,
        },
        autoExpand: {
            type: Boolean,
            default: false,
        },
        disableContractSelection: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            start: null,
            ordersVisible: false,
            assignmentsVisible: false,
            loading: 0,
            contractObject: null,
            showAll: false,
            weeks: [],
            orders: [],
            assignments: [],
            dutyOfficerSchedules: [],
        };
    },
    computed: {
        startDate() {
            if (this.contractObject.start_date instanceof Date) {
                return this.contractObject.start_date
            }
            return this.contractObject.start_date ? this.getDateFromString(this.contractObject.start_date) : null
        },
        endDate() {
            if (this.contractObject.end_date instanceof Date) {
                return this.contractObject.end_date
            }
            return this.contractObject.end_date ? this.getDateFromString(this.contractObject.end_date) : null
        },
        weekColWidth() {
            return Math.round(this.timeColWidth / 7) * 7;
        },
        isResizeMode() {
            return this.hoverMode === this.RESIZE_END || this.hoverMode === this.RESIZE_START;
        },
        orderlessAssignments() {
            // Create a copy to avoid mutating reactive data ! Chrome was able to resolve the previous implementation but
            // Firefox needs more explicit solution.
            const sortedAssignments = [...this.assignments];
            this.sortByDate(sortedAssignments);
            return sortedAssignments.filter((item) => item.work_order === null || item.work_order === undefined);
        }
    },
    watch: {
        calendarStartDate: function () {
            this.initTable();
        },
        calendarStartWeek: function () {
            this.initTable();
        },
    },
    mounted: function () {
        this.contractObject = this.contract;
        this.initTable();
        if (this.autoExpand) {
            this.toggleOrders();
        }
        this.fetchDutyOfficerSchedules();
    },
    methods: {
        fetchDutyOfficerSchedules() {
            if (!this.contract) {
                return;
            }
            this.restFetch(
                this.dutyOfficerScheduleUrl + `?contract=${this.contract.id}`,
                (response) => {
                    this.dutyOfficerSchedules = response.data;
                    // Notify ancestors so the duty officer form can re-sync its loaded user
                    this.$emit('dutyOfficerUpdated');
                },
                () => {
                }
            );
        },

        sortByDate(arr) {
            arr.sort((a, b) => {
                if (a.planned_start === undefined) {
                    return 1;
                }
                if (b.planned_start === undefined) {
                    return -1;
                }
                return new Date(b.planned_start).getTime() - new Date(a.planned_start).getTime();
            });
        },
        initTable() {
            this.weeks = [];
            this.start = this.calendarStartWeek;
            let startWeek = this.start;
            for (let i = 0; i < this.visibleWeeksLimit; i++) {
                this.weeks.push(this.$t("calendar.wk_prefix") + (startWeek + i));
            }
        },
        toggleAssignments() {
            this.assignmentsVisible = !this.assignmentsVisible;
        },
        toggleOrders(showAll = false) {
            this.ordersVisible = !this.ordersVisible;
            this.showAll = showAll;
            if (this.ordersVisible) {
                if (this.contract.orders) {
                    this.orders = this.contract.orders;
                } else {
                    this.fetchOrders();
                }
                this.fetchAssignments();
            }
        },
        fetchOrders: function () {
            this.loading++;
            this.orders = [];
            this.restFetchParams(this.orderUrl, { contract: this.contractObject.id }, this.handleOrders);
        },
        handleOrders: function (response) {
            this.loading--;
            if (response != null) {
                this.orders = response.data;
            }
        },
        refreshContract(contract) {
            this.contractObject = contract;
            this.fetchOrders();
        },
        fetchAssignments() {
            this.loading++;
            this.assignments = [];
            this.restFetchParams(this.workAssignmentUrl, { contract: this.contractObject.id }, this.handleAssignments);
        },
        handleAssignments(response) {
            this.loading--;
            if (response != null && response.data) {
                this.assignments = response.data;
                // Restore collapse/ expand state
                if (this.assignmentsVisible) {
                    this.$refs("assignmentsContainer").collapse("show");
                }
            }
        },
        emitShowOrder(order) {
            this.$emit("showOrder", order, this.contract);
        },
        emitAddOrder() {
            this.$emit("addOrder", this.contractObject ? this.contractObject : null);
        },
        emitAddAssignment(orderObject) {
            let contract = this.contractObject ? this.contractObject : null;
            if (contract) {
                contract.work_order = orderObject ? orderObject : null;
            }
            this.$emit("addAssignment", contract);
        },
        getOrderAssignments(orderId) {
            return this.assignments.filter((item) => item.work_order && item.work_order.id === orderId);
        },
        emitShowAssignment(assignment) {
            this.$emit("showAssignment", assignment);
        },
    },
};
</script>
<style scoped>
.calendar-item-container {
    user-select: none;
    white-space: nowrap;
}

.expanded {
    background: #ffffff !important;
}

.contract-header-text,
.week-item,
.order-text {
    display: inline-block;
    background: #ffffff;
    border-right: 1px #bcbcbc solid;
    border-top: 1px #bcbcbc solid;
    border-bottom: 1px #bcbcbc solid;
    margin: 0;
    padding: 0.1em;
    font-size: 0.9em;
    user-select: none;
    min-height: 2.3em;
}

.order-text {
    border-top: 1px #bcbcbc solid;
}

.contract-header-text {
    font-weight: bold;
    background: #f6f5f1;
}

.order-text {
    color: #404041;
    padding-left: 2.2em;
}

.contract-header-text:hover {
    color: #007bff;
    font-weight: bold;
    cursor: pointer;
}

.disabled-contract {
    color: #404041 !important;
    cursor: default;
}

.week-item {
    color: #ffffff;
    user-select: none;
    padding: 0.1em;
    display: inline-block;
    vertical-align: top;
    border-bottom:
}

.loading-container {
    padding: 0.5em;
    background: #ffffff;
    margin: 0;
}

.dropdown-adder {
    padding-top: 0;
    padding-bottom: 0;
    max-height: 1.4em;
}

.btn-sm {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.timeline-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.order-text,
.assignment-calendar-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
}

.btn-link {
    white-space: nowrap;
}

.single-line {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
